import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

import { Birthdate } from "components/Common/DatePicker"

//Import selects arrays
import { getLicensedStates, unitTypes } from "common/selects"

import { getSession, } from "../../../helpers/AuthType/authService"

import {
  fnSsnTestSubjectVerification,
} from "../../../helpers/Application/applicationService"

const PersonalInformationForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
  setFieldError,
}) => {

  let {merchant : {tu_testmode : testmode}} = getSession();

  const handleRemoteSsnValidation = async (e) => {
    
    handleBlur(e)

  console.log({target : e.target})

    let value = e.target.value.replace(/[^0-9]/g, "");
    let id = e.target.id    

    if (testmode && id == "ssn" && value && value.length == 9) {
      var response = await fnSsnTestSubjectVerification(value)

      if(!response)
        setFieldError(id,  "Invalid Test Subject Social Security Number. Please consult ESF for list of avaialble Test Social Security Numbers")
    }
  }
 
  useEffect(() => {}, [])

  return (
    <React.Fragment>
      <Form className="form-horizontal" id="step-1-form">
        <Row>
          <Col lg="12">
            <Input
              type="hidden"
              id="key"
              name="key"
              value={values.key || ""}
              invalid={errors.key ? true : false}
            />
            {touched.key && errors.key ? (
              <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
              >
                {errors.key}
              </FormFeedback>
            ) : null}
            <Input
              type="hidden"
              id="pin"
              name="pin"
              value={values.pin || ""}
              invalid={errors.pin ? true : false}
            />
            {touched.pin && errors.pin ? (
              <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
              >
                {errors.pin}
              </FormFeedback>
            ) : null}
            <Input
              type="hidden"
              id="code"
              name="code"
              value={values.code || ""}
              invalid={errors.code ? true : false}
            />
            {touched.code && errors.code ? (
              <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
              >
                {errors.code}
              </FormFeedback>
            ) : null}
            <Input
              type="hidden"
              id="applicantid"
              name="applicantid"
              value={values.applicantid || ""}
              invalid={errors.applicantid ? true : false}
            />
            {touched.applicantid && errors.applicantid ? (
              <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
              >
                {errors.applicanttypeid}
              </FormFeedback>
            ) : null}
            <FormGroup className="mb-3">
                <Label htmlFor="ssn">Social Security Number</Label>
                <Input
                    type="text"
                    className="form-control"
                    id="ssn"
                    placeholder="Enter Social Security Number"
                    onChange={handleChange}               
                    //onBlur={handleBlur}
                    onBlur={e => {
                      handleRemoteSsnValidation(e)
                    }}
                    value={values.ssn || ""}
                    invalid={
                    touched.ssn && errors.ssn ? true : false
                    }
                />
                {touched.ssn && errors.ssn ? (
                    <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.ssn}
                    </FormFeedback>
                ) : null}
            </FormGroup>
          </Col>
        </Row>
        <Row>
            <Col lg="6" >            
                <FormGroup className="mb-3">
                <Label htmlFor="firstname">First Name</Label>
                <Input
                    type="text"
                    className="form-control"
                    id="firstname"
                    placeholder="Enter First Name"
                    onChange={handleChange}               
                    onBlur={handleBlur}
                    value={values.firstname || ""}
                    invalid={
                    touched.firstname && errors.firstname ? true : false
                    }
                />
                {touched.firstname && errors.firstname ? (
                    <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.firstname}
                    </FormFeedback>
                ) : null}
                </FormGroup>
            </Col>
          <Col lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="lastname">Last Name</Label>
              <Input
                type="text"
                className="form-control"
                id="lastname"
                placeholder="Enter Last Name"
                onChange={handleChange}                
                onBlur={handleBlur}
                value={values.lastname || ""}
                invalid={
                  touched.lastname && errors.lastname ? true : false
                }
              />
              {touched.lastname && errors.lastname ? (
                <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                  {errors.lastname}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
        </Row>
        <Row>
            <Col lg="6">
              <div className="mb-3">
                <Birthdate
                  name={"birthdate"}
                  id={"birthdate"}
                  label={"Date Of Birth"}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  validation={{values,errors,touched,setFieldValue,setFieldTouched}}
                />
              </div>
            </Col>
          </Row>
          <Row>
              <Col lg="12">
                <div className="mb-3">
                  <Label for="email">Email</Label>
                  <Input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter Email Address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email || ""}
                    invalid={
                      touched.email &&
                      errors.email
                        ? true
                        : false
                    }
                  />
                  {touched.email &&
                  errors.email ? (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.email}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="cellphone">Cell Phone</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="cellphone"
                    name="cellphone"
                    placeholder="Enter Cell Phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.cellphone || ""}
                    invalid={
                      touched.cellphone &&
                      errors.cellphone
                        ? true
                        : false
                    }
                  />
                  {touched.cellphone &&
                  errors.cellphone ? (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.cellphone}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="homephone">Home Phone</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="homephone"
                    name="homephone"
                    placeholder="Enter Home Phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.homephone || ""}
                    invalid={
                      touched.homephone &&
                      errors.homephone
                        ? true
                        : false
                    }
                  />
                  {touched.homephone &&
                  errors.homephone ? (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.homephone}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3">
                  <Label for="workphone">Work Phone</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="workphone"
                    name="workphone"
                    placeholder="Enter Work Phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.workphone || ""}
                    invalid={
                      touched.workphone &&
                      errors.workphone
                        ? true
                        : false
                    }
                  />
                  {touched.workphone &&
                  errors.workphone ? (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.workphone}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>          

            <Row>
              <Col lg="12">
                <div className="mb-3">
                  <Label for="addr">Address</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="addr"
                    name="addr"
                    placeholder="Enter Address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.addr || ""}
                    invalid={
                      touched.addr &&
                      errors.addr
                        ? true
                        : false
                    }
                  />
                  {touched.addr &&
                  errors.addr ? (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.addr}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Input
                type="hidden"
                id="addr2"
                name="addr2"
                value={values.addr2 || ""}
                invalid={
                  errors.addr2 ? true : false
                }
              />
              {touched.addr2 &&
              errors.addr2 && (
                <FormFeedback
                  type="invalid"
                  style={{ fontSize: "100%" }}
                >
                  {errors.addr2}
                </FormFeedback>
              )}
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="city">City</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    placeholder="Enter  City"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.city || ""}
                    invalid={
                      touched.city &&
                      errors.city
                        ? true
                        : false
                    }
                  />
                  {touched.city &&
                  errors.city && (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.city}
                    </FormFeedback>
                  )}
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label>State</Label>
                  <Select
                    id="state"
                    name="state"
                    placeholder="Select State"
                    defaultValue={values.state}
                    value={values.state}
                    onBlur={e => {
                      setFieldTouched("state",true);
                    }}
                    onChange={selectedOption => {
                      let event = {
                        target: {
                          name: "state",
                          value: selectedOption,
                        },
                      }
                      handleChange(event)
                    }}
                    isSearchable={true}
                    options={getLicensedStates()}
                    isLoading={false}
                    loadingMessage={() => "loading states"}
                    noOptionsMessage={() => "states"}
                    invalid={
                      touched.state &&
                      errors.state &&
                      errors.state.value
                        ? true
                        : false
                    }
                  />
                  {touched.state &&
                  errors.state &&
                  errors.state.value && (
                    <FormFeedback
                      type="invalid"
                      style={{
                        display: "block",
                        fontSize: "100%",
                      }}
                    >
                      {errors.state.value}
                    </FormFeedback>
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="zipcode">Zipcode</Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="zipcode"
                    name="zipcode"
                    placeholder="Enter Zipcode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.zipcode || ""}
                    invalid={
                      touched.zipcode &&
                      errors.zipcode
                        ? true
                        : false
                    }
                  />
                  {touched.zipcode &&
                  errors.zipcode && (
                    <FormFeedback
                      type="invalid"
                      style={{ fontSize: "100%" }}
                    >
                      {errors.zipcode}
                    </FormFeedback>
                  )}
                </div>
              </Col>
            </Row>
      </Form>
    </React.Fragment>
  )
}

export default PersonalInformationForm 
